<template>
  <v-layout row>
    <v-flex md12>
      <v-card>
        <v-toolbar dense primary-title>
          <v-toolbar-title>
            {{$t('view.perfil.registros.label')}}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="view.elem.showTable = !view.elem.showTable">
            <v-icon>{{ view.elem.showTable ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
          </v-btn>
        </v-toolbar>
        <v-slide-y-transition>
        <v-card-text v-show="view.elem.showTable">
          <v-flex md12>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="view.elem.table.search"
                append-icon="search"
                :label="$t('view.global.common.buscar')"
                single-line
                hide-details
              ></v-text-field></v-flex>
          <v-layout row class="table-responsive">
            <v-flex md12>
              <v-data-table
                :headers="view.elem.table.headers"
                :items="view.elem.table.data"
                :pagination.sync="view.elem.table.pagination"
                :search="view.elem.table.search" >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.clave }}</td>
                  <td class="text-xs-center">
                    {{ props.item.numeroComercio }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.name }}
                  </td>
                  <td class="justify-center layout px-0">
                    <v-tooltip v-show="$userPermission.hasPermission('ROLE_MODIFICAR_COMERCIO')" top>
                      <v-btn  
                        @click="emitEventEditRow(props.item.clave)" 
                        color="primary"
                        icon slot="activator" fab small>
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                      <span>Editar</span>
                    </v-tooltip>
                    <v-tooltip v-show="$userPermission.hasPermission('ROLE_DESACTIVAR_COMERCIO') && props.item.status " top>
                      <v-btn  
                        @click="emitEventDeleteRow(props.item.clave)" 
                        color="primary"
                        icon slot="activator" fab small>
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                      <span>Eliminar</span>
                    </v-tooltip>
                    <v-tooltip v-show="$userPermission.hasPermission('ROLE_ACCESO_AUDITORIA')" top>
                      <v-btn 
                        @click="emitEventAuditRow({id:props.item.clave, adit:'TComercioSucursal', dataDescripcion:props.item.name})" 
                        icon slot="activator" color="primary" fab small>
                        <v-icon>storage</v-icon>
                      </v-btn>
                      <span>{{$t('view.global.common.auditoria')}}</span>
                    </v-tooltip>
                  </td>
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                  {{$t('view.global.common.no-data-text')}} "{{ view.elem.table.search }}" 
                </v-alert>
                <v-alert slot="no-data" :value="true" color="warning" icon="warning">
                  {{$t('view.global.common.no-data-text')}}
                </v-alert>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-card-text>
        </v-slide-y-transition>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import SucursalAPI from "@/services/generales/sucursal";
import {getErrors,getBusinessCode,getResponseDTO,handleResponseMessage} from '@/helpers/http-response-handler';
import tippy from 'tippy.js';

export default {
  props:["comercio"]
  , data() {
    return {
      count:0
      , sucursales: []
      , dataTable:undefined
      , view:{
        elem:{
          showTable: true
          , table:{
            data:[]
            , search:''
            , show: true
            , pagination: {
              sortBy: 'clave'
              , descending: true
            }
            , headers: [
                {
                  text: this.$t('view.global.common.clave'),
                  align: 'center',
                  sortable: true,
                  value: 'clave'
                },
                {
                  text: this.$t('view.comercio.numeroComercio'),
                  align: 'center',
                  sortable: true,
                  value: 'numeroComercio'
                },
                {
                  text: this.$t('view.comercio.name'),
                  align: 'left',
                  sortable: true,
                  value: 'name'
                },
                {
                  text: 'Acciones',
                  align: 'center',
                  sortable: false,
                  value: 'clave'
                },
              ]
          }
        }
      }
    }
  }
  
  ,methods: {
    async deleteRow(clave){
      try{
        const swalResponse = await this.$swal({
          title: this.$t('view.global.swal.disable.title')
          , text: this.$t('view.global.swal.disable.text')
          , type: this.$t('view.global.swal.disable.type')
          , showCancelButton: this.$t('view.global.swal.disable.showCancelButton')
          , confirmButtonColor: this.$t('view.global.swal.disable.confirmButtonColor')
          , cancelButtonColor: this.$t('view.global.swal.disable.cancelButtonColor')
          , confirmButtonText: this.$t('view.global.swal.disable.confirmButtonText')
          , cancelButtonText: this.$t('view.global.swal.disable.cancelButtonText')
          , reverseButtons: true
        });
        if(swalResponse.value){
          const response = await SucursalAPI.disable({clave});
          handleResponseMessage({response: response,modulo:'Sucursal'});
        }
      }catch(error){
        console.log(error)
      }
    }
    , refreshData(){
      this.getSucursales();
    }
    ,async getSucursales(){
      try{
        let respuesta = await SucursalAPI.list(this.$parent.comercio);
        const responseDTO = getResponseDTO(respuesta);
        this.view.elem.table.data = responseDTO.dtr;
      }catch(error){
        console.error(error)
      }
    }
    , emitEventEditRow(id){
      this.$emit('editRow', id);
      this.view.elem.showTable = false;
    }
    , emitEventDeleteRow(id){
      this.deleteRow(id)
      .then(response=>{
        this.getSucursales();
      })
      .catch(console.log);
    }
    , emitEventAuditRow(auditoria){
      const {id,dataDescripcion} = auditoria;
      this.$emit('auditRow', id,dataDescripcion);
    }
  }
  , computed:{}
  , components: {}
  // Instance Lifecycle Hooks
  , created(){

  }
  , mounted(){
    this.getSucursales();
    // const vm = this;
    // function emitEventDeleteRow(event){
    //   const {id} = this;
    //   vm.deleteRow(id)
    //   .then(response=>{
    //     vm.dataTable._fnAjaxUpdate();
    //   })
    //   .catch(console.log);
    // }
    // function emitEventEditRow(event){
    //   const {id} = this;
    //   vm.$emit('editRow', id);
    // };
    // function emitEventAuditRow(event){
    //   const {audit,dataDescripcion} = this;
    //   vm.$emit('auditRow', audit,dataDescripcion);
    // };

    // function emitEventUnLockRow(event){
    //   const {id} = this;
    //   vm.$emit('unLockRow', id);
    // };

    // function emitEventSucursalRow(event){
    //   const {id} = this;
    //   vm.$emit('sucursalRow', id);
    // };

    // function newDeleteButton(id,eventFunction){
    //   const button = document.createElement('button');
    //   const link = document.createElement('i');
    //   const label = document.createElement('span');
    //   //button settings
    //   button.setAttribute("title","Desactivar");
    //   button.classList.add('btn', 'btn-action-delete', 'button', 'button--sacnite', 'button--round-l', 'custom');
    //   button.id = id || "";
    //   button.onclick = eventFunction;
    //   //link
    //   link.classList.add('button__icon', 'icon', 'fa', 'fa-trash-o');
    //   //label settings
    //   label.appendChild(document.createTextNode('delete'))
    //   //Append link and label within the button
    //   button.appendChild(link);
    //   button.appendChild(label);
      
    //   return button;
    // };
    // function newEditButton(id,eventFunction){
    //   const button = document.createElement('button');
    //   const link = document.createElement('i');
    //   const label = document.createElement('span');
    //   //button settings
    //   button.setAttribute("title","Editar");
    //   button.classList.add('btn', 'btn-action-edit', 'button', 'button--sacnite', 'button--round-l', 'custom');
    //   button.id = id || "";
    //   button.onclick = eventFunction;
    //   //link
    //   link.classList.add('button__icon', 'icon', 'fa', 'fa-pencil');
    //   //label settings
    //   label.appendChild(document.createTextNode('edit'))
    //   //Append link and label within the button
    //   button.appendChild(link);
    //   button.appendChild(label);
      
    //   return button;
    // };
    // function newAuditButton(id,dataDescripcion,eventFunction){
    //   const button = document.createElement('button');
    //   const link = document.createElement('i');
    //   const label = document.createElement('span');
    //   //button settings
    //   button.setAttribute("title","Auditoría");
    //   button.classList.add('btn', 'button', 'button--sacnite', 'button--round-l', 'custom');
    //   button.audit = id || "";
    //   button.dataDescripcion = dataDescripcion || "";
    //   button.onclick = eventFunction;
    //   //link
    //   link.classList.add('button__icon', 'icon', 'fa', 'fa-database');
    //   //label settings
    //   label.appendChild(document.createTextNode('audit'))
    //   //Append link and label within the button
    //   button.appendChild(link);
    //   button.appendChild(label);
      
    //   return button;
    // };

    // function newUnLockButton(id,eventFunction){
    //   const button = document.createElement('button');
    //   const link = document.createElement('i');
    //   const label = document.createElement('span');
    //   //button settings
    //   button.setAttribute("title","Desbloquear Espera Respuesta");
    //   button.classList.add('btn', 'button', 'button--sacnite', 'button--round-l', 'custom');
    //   button.id = id || "";
    //   button.onclick = eventFunction;
    //   //link
    //   link.classList.add('button__icon', 'icon', 'mdi', 'mdi-lock-open');
    //   //label settings
    //   label.appendChild(document.createTextNode('unlock'))
    //   //Append link and label within the button
    //   button.appendChild(link);
    //   button.appendChild(label);
      
    //   return button;
    // };

    // function newSucursalButton(id,eventFunction){
    //   const button = document.createElement('button');
    //   const link = document.createElement('i');
    //   const label = document.createElement('span');
    //   //button settings
    //   button.setAttribute("title","Sucursal");
    //   button.classList.add('btn', 'button', 'button--sacnite', 'button--round-l', 'custom');
    //   button.id = id || "";
    //   button.onclick = eventFunction;
    //   //link
    //   link.classList.add('button__icon', 'icon', 'mdi', 'mdi-cash-multiple');
    //   //label settings
    //   label.appendChild(document.createTextNode('sucursal'))
    //   //Append link and label within the button
    //   button.appendChild(link);
    //   button.appendChild(label);
      
    //   return button;
    // };



    
  }
};
</script>



// WEBPACK FOOTER //
// src/views/generales/comercio/SucursalDataTable.vue